<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>设备类型：</label>
                        <el-select v-model="search_Obj.f_device_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('device_type3')" :key="'device_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>设备编号：</label>
                        <el-input v-model="search_Obj.f_device_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="device_type" label="设备类型" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.device_type, "device_type3") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="device_code" label="出厂编号" sortable="custom"></el-table-column>
                        <el-table-column prop="check_date" label="检测时间" sortable="custom"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                        <el-table-column label="操作" width="150" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看设备检测记录"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceTestLogList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '设备检测记录',
            menu_id: 3386,
            list_url: "/api/admin/devicetestlog/list",
            search_Obj: {
                f_device_type: '',
                f_device_code: '',
            },
            del_Obj:{
                url:'/api/admin/devicetestlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_type3'],
        };
    },
    methods: {}
};
</script>